module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEXTt+e9X/kXAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/table/dot.png
// module id = ./src/styles/table/dot.png
// module chunks = 21